<script>
// import MapboxGL from "mapbox-gl";
import Vue from 'vue';

// eslint-disable-next-line vue/one-component-per-file
export default {
  name: 'MapboxMarker',

  inject: ['getMap', 'addMarker', 'removeMarker', 'getMarker', 'setPopupItem'],

  props: {
    id: {
      type: String,
      required: true,
    },
    marker: {
      type: Object,
      required: true,
    },
    primary: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      markerdestroyed: false,
      markercreated: false,
    };
  },

  created() {
    const vm = this;
    this.getMap(function () {
      if (vm.markerdestroyed) {
        console.warn('destroyed', vm.id);
        return;
      }
      const m = vm.createMarker(vm.marker);
      vm.addMarker(vm.id, m);
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.removeMarker(this.id);
  },

  methods: {
    createMarker(point) {
      const el = document.createElement('div');
      el.addEventListener('click', this.onClickMarker);
      el.style.zIndex = '100';
      if (this.primary) {
        el.style.zIndex = '1000';
      }

      // eslint-disable-next-line no-undef
      const m = new mapboxgl.Marker(el).setLngLat(point.geometry.coordinates);

      // const vm = this;
      const defaultSlot = this.$slots.default[0];

      if (defaultSlot) {
        // eslint-disable-next-line vue/one-component-per-file
        const Comp = Vue.extend({
          render(/*createElement*/) {
            return defaultSlot;

            // Try to forward data to new component
            // const createdElement = createElement(
            //   `div`,
            //   vm.$parent.$parent.$vnode,
            //   [defaultSlot]
            // );
            // return createdElement;
          },
        });

        // TODO: is it possible to bind destoryed hook ?
        const compInstance = new Comp().$mount();

        el.appendChild(compInstance.$el);
      } else {
        console.warn('Marker template not found');
        el.innerHTML = `X`;
      }

      this.markercreated = true;

      return m;
    },

    onClickMarker(ev) {
      ev.stopPropagation();
      this.setPopupItem(this.marker);
    },
  },

  render() {
    return null;
  },
};
</script>

